import * as React from "react";
import { connect } from "react-redux";
import { IdStyles } from "../../less/IdStyles";
import { selectSelectedLeagueEventData, selectTournamentDetailedRankings, } from "../../selectors/selectTournamentInfo";
import { EventType } from "../balancing/types/BalancingCore";
import { RankingPlacementLeague } from "./RankingPlacementLeague";
var _TabTournamentRanking = function (_a) {
    var rankings = _a.rankings, rowType = _a.rowType;
    var renderedElements = rankings.map(function (ranking, index) {
        return React.createElement(RankingPlacementLeague, { key: index, ranking: ranking, rowType: rowType });
    });
    return (React.createElement("div", { className: IdStyles.TournamentGroupRankingContainer + " page-overflow-y" }, renderedElements));
};
var mapState = function (state) {
    var infos = selectSelectedLeagueEventData(state);
    return {
        rankings: selectTournamentDetailedRankings(state),
        rowType: infos && infos.balancing ? infos.balancing.type : EventType.PlayerLeague,
    };
};
export var TabTournamentRanking = connect(mapState)(_TabTournamentRanking);



//////////////////
// WEBPACK FOOTER
// ./src/features/tournament-building/TabTournamentRanking.tsx
// module id = 2796
// module chunks = 3